import profiles2 from "../assets/imgs/js.png";
import profiles from "../assets/imgs/python.png";
import profiles3 from "../assets/imgs/postgresql.png";
import react from "../assets/imgs/react.png";
import python from '../assets/imgs/python.png'
import github from '../assets/brands/github.png'
import js from '../assets/imgs/js.png'
import linkedin from '../assets/brands/linkedin.png'

export const types = {
  logIn: "logIn",
  logOut: "logOut",
  permissAdmin: "permissAdmin",
  dark: "dark",
};

export const options = [
  // options for filter
  {
    value: "projects",
    label: "projects",
  },
  {
    value: "certifications",
    label: "certifications",
  },
];

export const works = [
  {
    id:1,
    title: "Quito Consulting",
    details: [
      {
        id:1,
        details: "Help with the activities that require programming o configuration with the plataform Microsoft."
      },
      {
        id:2,
        details: "Create manually for users"
      }
    ],
    year: "free time",
  },
  {
    id:2,
    title: "Diverzu",
    details:[
      {
        id:1,
        details:"Create modules for automate businness's management"
      }
    ],
    year: "November 2020 - Octuber 2021",
  },
  {
    id:3,
    title: "Frontend Café",
    details:[
      {
        id:1,
        details:"Create api with NextJS with TypeScript with firebase database for CMY5",
      }
    ],
    year: "August 2022 - September 2022",
  },
  {
    id:4,
    title: "Universidad Laica Eloy Alfaro Manabí",
    details:[
      {
        id:1,
        details: "Developer Intership, create app with PowerApps Sharepoint among others",
      }
    ],
    year: "November 2020 - Octuber 2021",
  },
  
];

export const Imgs = [
  {
    id: 1,
    img: profiles,
  },
  {
    id: 1,
    img: profiles2,
  },
  {
    id: 2,
    img: profiles3,
  },
  {
    id: 2,
    img: react,
  }
];

export const Contact = [
  {
    id:1,
    img: github,
    url: "https://github.com/bryanedward"
  },
  {
    id:2,
    img: linkedin
  ,url:"https://www.linkedin.com/in/bryanpomaqueroquimiz/"
  }
]


export const colorsImg = [
  {
    id:1,
    backgroundColor: "#0088FE",
    img: react 
  },
  {
    id:2,
    backgroundColor: "#00C49F",
    img: python 
  
  },
  {
    id:3,
    backgroundColor:"#FFBB28",
    img: js 

  }
]